import axios from 'axios'

// Serviço para consulta de CNPJ usando Brasil API (gratuito)
// Documentação: https://brasilapi.com.br/docs#tag/CNPJ
// Formato da URL: https://brasilapi.com.br/api/cnpj/v1/{cnpj}
// Limite: Sem limite oficial, mas use com moderação
const cnpjService = axios.create({
  baseURL: "https://brasilapi.com.br/api/cnpj/v1",
  headers: {
    "Content-Type": 'application/json',
  },
  timeout: 10000, // 10 segundos de timeout
});

export default cnpjService;